"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expressionTypes = exports.types = void 0;
var types;
(function (types) {
    types["ALT"] = "alt";
    types["ASK"] = "ask";
    types["BGP"] = "bgp";
    types["CONSTRUCT"] = "construct";
    types["DESCRIBE"] = "describe";
    types["DISTINCT"] = "distinct";
    types["EXPRESSION"] = "expression";
    types["EXTEND"] = "extend";
    types["FILTER"] = "filter";
    types["FROM"] = "from";
    types["GRAPH"] = "graph";
    types["GROUP"] = "group";
    types["INV"] = "inv";
    types["JOIN"] = "join";
    types["LEFT_JOIN"] = "leftjoin";
    types["LINK"] = "link";
    types["MINUS"] = "minus";
    types["NOP"] = "nop";
    types["NPS"] = "nps";
    types["ONE_OR_MORE_PATH"] = "OneOrMorePath";
    types["ORDER_BY"] = "orderby";
    types["PATH"] = "path";
    types["PATTERN"] = "pattern";
    types["PROJECT"] = "project";
    types["REDUCED"] = "reduced";
    types["SEQ"] = "seq";
    types["SERVICE"] = "service";
    types["SLICE"] = "slice";
    types["UNION"] = "union";
    types["VALUES"] = "values";
    types["ZERO_OR_MORE_PATH"] = "ZeroOrMorePath";
    types["ZERO_OR_ONE_PATH"] = "ZeroOrOnePath";
    types["COMPOSITE_UPDATE"] = "compositeupdate";
    types["DELETE_INSERT"] = "deleteinsert";
    types["LOAD"] = "load";
    types["CLEAR"] = "clear";
    types["CREATE"] = "create";
    types["DROP"] = "drop";
    types["ADD"] = "add";
    types["MOVE"] = "move";
    types["COPY"] = "copy";
})(types = exports.types || (exports.types = {}));
var expressionTypes;
(function (expressionTypes) {
    expressionTypes["AGGREGATE"] = "aggregate";
    expressionTypes["EXISTENCE"] = "existence";
    expressionTypes["NAMED"] = "named";
    expressionTypes["OPERATOR"] = "operator";
    expressionTypes["TERM"] = "term";
    expressionTypes["WILDCARD"] = "wildcard";
})(expressionTypes = exports.expressionTypes || (exports.expressionTypes = {}));
//# sourceMappingURL=algebra.js.map